<!-- Define our page card. -->
<mat-card class="mat-page-card">

  <!-- Define the header of our page card. -->
  <mat-card-header>

    <!-- Give our page an icon. -->
    <mat-icon mat-card-avatar color="icon-orange">dashboard</mat-icon>

    <!-- Give our page a main title. -->
    <mat-card-title>
      PrismHR Integration Administration
    </mat-card-title>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle>Centralized source of truth for the PrismHR Integration.</mat-card-subtitle>
  </mat-card-header>

  <!-- Define the content of our page card. -->
  <mat-card-content>
    <div>
      <p>
        This UI allows you to view the current state of the PrismHR Integration with controls for mapping new PEOs and
        Client-Customers.  Along with PrismHR API Credential setup and testing.  To map a new PEO, navigate to
        <a routerLink="/admin/peo">PEO Management</a> and click the &nbsp; <mat-icon color="icon-green">add</mat-icon>
        &nbsp; icon. To view, modify or map a new Client-Customer [from the PEO Management page], click the &nbsp;
        <mat-icon color="icon-slate">group</mat-icon> &nbsp; icon to view a PEO's existing Client-Customer mappings and
        from there click either the &nbsp; <mat-icon color="primary">edit</mat-icon> &nbsp; icon to modify the existing
        mapping or the &nbsp; <mat-icon color="primary">add</mat-icon> &nbsp; icon to add a new mapping.  An alternative
        to this [for importing in bulk] you may also use the <a routerLink="/admin/import/wizard">PEO Client-Customer Import Wizard</a>.
      </p>
    </div>
  </mat-card-content>
</mat-card>
